@if (category$ | async; as category) {
<div class="category-name" [attr.data-testing-id]="'category-' + category.uniqueId">
  <a [routerLink]="category | ishCategoryRoute">
    <custom-category-image [category]="category" />
    <h3>{{ category.name }}</h3>
  </a>
</div>
}
